import { Box } from "@mui/material";
import type { BoxProps } from "@mui/material";
import type { ElementType } from "react";

export const panelSx = (tone = "primary.main") => ({
  borderStyle: "solid",
  borderColor: tone,
  borderWidth: "1px",
  borderLeftWidth: "3px",
  backgroundColor: "custom.panelSurface",
  px: 1,
  py: 0.75,
});

type PanelProps = Omit<BoxProps, "component"> & {
  tone?: string;
  component?: ElementType;
};

const Panel = ({ tone, sx, ...props }: PanelProps) => (
  <Box {...props} sx={[panelSx(tone), ...(Array.isArray(sx) ? sx : [sx])]} />
);

export default Panel;
